import React from "react";
import {
  HeaderBackground,
  HeaderContainer,
  HeaderContent,
  HeaderEyebrow,
  HeaderOverlay,
  HeaderSubtitle,
  HeaderTitle,
} from "./PageHeaderElements";

const PageHeader = ({ eyebrow, title, subtitle }) => {
  return (
    <HeaderContainer>
      <HeaderBackground
        src={require("../../../assets/images/honeycomb.JPG")}
        alt=""
      />
      <HeaderOverlay />
      <HeaderContent>
        {eyebrow && <HeaderEyebrow $light>{eyebrow}</HeaderEyebrow>}
        <HeaderTitle>{title}</HeaderTitle>
        {subtitle && <HeaderSubtitle>{subtitle}</HeaderSubtitle>}
      </HeaderContent>
    </HeaderContainer>
  );
};

export default PageHeader;
